"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var test_attributes_1 = require("@hip/test-attributes");
var halcyon_components_react_1 = require("@realm-kf/halcyon-components-react");
var brandIcon_1 = require("@hip/components/src/components/brandIcon/brandIcon");
var header_module_css_1 = __importDefault(require("./header.module.css"));
var Header = function (_a) {
    var opco = _a.opco, onExit = _a.onExit, onHome = _a.onHome;
    return (react_1.default.createElement("div", { className: classnames_1.default(header_module_css_1.default.Header, 'hlcn-u-align-space-between', 'hlcn-u-pl-small', 'hlcn-u-pr-medium'), "data-test-id": test_attributes_1.dataTestId.configurator.layout.headerContainer },
        react_1.default.createElement(halcyon_components_react_1.Button, { classes: header_module_css_1.default.HomeButton, variant: "action", onClick: onHome, "data-test-id": test_attributes_1.dataTestId.configurator.layout.logoBtn },
            react_1.default.createElement(brandIcon_1.BrandIcon, { opco: opco })),
        react_1.default.createElement(halcyon_components_react_1.Button, { variant: "action", onClick: onExit, "data-test-id": test_attributes_1.dataTestId.configurator.layout.exitBtn },
            react_1.default.createElement(halcyon_components_react_1.Text, { color: "dark", weight: "regular", classes: header_module_css_1.default.ExitButtonLabel, "data-test-id": test_attributes_1.dataTestId.configurator.layout.exitBtnLabel },
                "Exit project",
                react_1.default.createElement(halcyon_components_react_1.Icon, { color: "dark", classes: "hlcn-u-ml-small", type: "Error" })))));
};
exports.Header = Header;
